/**
 * Login embutido no app — Resource Owner Password Grant direto no Keycloak (realm `storeo`,
 * client `storeo-admin`, role `platform-staff`). Mesmo padrão de `apps/painel/src/lib/
 * authClient.ts` — duplicado de propósito (2 consumidores só, não vale a abstração ainda).
 * `sessionStorage` só — a sessão cai com a aba.
 */

const BASE = import.meta.env.VITE_KEYCLOAK_BASE_URL ?? 'http://localhost:8081';
const REALM = import.meta.env.VITE_KEYCLOAK_REALM ?? 'storeo';
const CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT ?? 'storeo-admin';

const ISSUER = `${BASE}/realms/${REALM}`;
const TOKEN_KEY = 'storeo:admin:token';

export async function login(email: string, password: string): Promise<void> {
  const res = await fetch(`${ISSUER}/protocol/openid-connect/token`, {
    method: 'POST',
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      grant_type: 'password',
      client_id: CLIENT_ID,
      username: email,
      password,
      scope: 'openid email',
    }),
  });
  if (!res.ok) throw new Error('E-mail ou senha incorretos');
  const body = (await res.json()) as { access_token: string };
  sessionStorage.setItem(TOKEN_KEY, body.access_token);
}

export function currentToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function logout(): void {
  sessionStorage.removeItem(TOKEN_KEY);
}

export interface TokenClaims {
  name?: string;
  email?: string;
  exp?: number;
  realm_access?: { roles?: string[] };
}

/** Só pra UI (nome/e-mail/expiração) — a validação de verdade é sempre do lado da API. */
export function decodeClaims(token: string): TokenClaims | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(json) as TokenClaims;
  } catch {
    return null;
  }
}

export function isExpired(claims: TokenClaims | null): boolean {
  if (!claims?.exp) return true;
  return Date.now() >= claims.exp * 1000;
}
